import { useCallback } from 'react';
import { useTracker } from '@archipro-website/tracker';

/**
 * Reports a reader opening a team member's details, as the legacy profile's
 * team tiles did: `ProfessionalExpandTeamClick`, with no item of its own, to
 * the ArchiPro tracker only.
 */
export const useExpandTeamClickReport = () => {
    const tracker = useTracker();

    return useCallback(() => {
        void tracker.log('ProfessionalExpandTeamClick', {
            url: new URL(window.location.href),
            targetTracker: 'archiproTracker',
        });
    }, [tracker]);
};
